module.exports = __webpack_public_path__ + "static/media/icon-setting.f07d814e.png";